import { createFileRoute } from '@tanstack/react-router'
import { ResourcesIndexPage } from '@/features/resources/components/resources-index-page'
import { buildResourcesIndexHead } from '@/features/resources/seo/resource-seo'

export const Route = createFileRoute('/$lang/resources/')({
  head: () => buildResourcesIndexHead('ru'),
  component: RussianResourcesIndexPage,
  staticData: { layout: 'public' },
})

function RussianResourcesIndexPage() {
  return <ResourcesIndexPage language="ru" />
}
